import {Component, Input} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {Waypoint, WaypointType, TOAST_STATE} from "@model";
import {LoaderService, ToastService, WaypointService} from "@services";
import {TranslocoService} from "@ngneat/transloco";
import {RaceWaypointsComponent} from "@pages";
import {finalize, forkJoin} from "rxjs";

@Component({
    selector: 'select-waypoint-from-event-modal',
    templateUrl: './select-waypoint-from-event-modal.component.html',
    styleUrls: ['./select-waypoint-from-event-modal.component.scss'],
    standalone: false
})
export class SelectWaypointFromEventModalComponent {
  @Input() listOfWaypoints: Waypoint[] | undefined;
  @Input() title: string | undefined;
  @Input() dismissButtonTitle: string | undefined;
  @Input() raceWaypointsComponent?: RaceWaypointsComponent;

  constructor(public activeModal: NgbActiveModal, private waypointService:WaypointService,
              private loaderService:LoaderService, private toastService:ToastService, private translocoService:TranslocoService) {
  }

  onDeleteWaypoint(waypoint:Waypoint): void {
    this.loaderService.startLoading();
    this.waypointService.deleteWaypoint(waypoint.id!, undefined, () => {
      this.raceWaypointsComponent!.resetForm();
      forkJoin({
        eventWaypoints: this.waypointService.findEventWaypoints(this.raceWaypointsComponent!.event!.id!),
        raceWaypoints: this.waypointService.findWaypoints(this.raceWaypointsComponent!.race!.id!)
      }).pipe(finalize(() => this.loaderService.dismissLoading())).subscribe(({eventWaypoints, raceWaypoints}) => {
        this.loaderService.dismissLoading();
        this.toastService.showToast(TOAST_STATE.success, this.translocoService.translate("organiser.event.details.control.point.delete.success"));
        this.listOfWaypoints = eventWaypoints;
        this.raceWaypointsComponent!.waypointList = raceWaypoints;
        this.raceWaypointsComponent!.waypointListChange.emit(raceWaypoints);
      });
    }, () => {
      this.loaderService.dismissLoading();
      this.toastService.showToast(TOAST_STATE.danger, this.translocoService.translate("organiser.event.details.control.point.delete.error"));
    });
  }

  onCopyWaypoint(waypoint:Waypoint): void {
    this.activeModal.close(waypoint);
  }

  onDismissClick(): void {
    this.activeModal.dismiss();
  }

  protected readonly WaypointType = WaypointType;
}
